import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '@environment/environment';
import { ChaseAdvancePaymentProcessInput } from '@advancedetailcompenent/advance-payment-status/Model/ChaseAdvancePaymentProcessInput';
import { ChaseAdvancePaymentTransactionStatus } from '@advancedetailcompenent/advance-payment-status/Model/ChaseAdvancePaymentTransactionStatus';
import { GetEnvVarService } from "../../../../service/get-env-var.service";

@Injectable()
export class AdvancePaymentStatusServiceService {

  private baseUrl: string;

  constructor(private http: Http, private getEnvVarService: GetEnvVarService) {
    this.baseUrl = this.getEnvVarService.getInvoiceservicebaseurl();
  }


  getTransactionStatusFromUID(uId: string): Observable<ChaseAdvancePaymentTransactionStatus> {
    // debugger;
    return this.http.get(this.baseUrl + `/api/advancePayments/getTransactionStatusFromUID/` + uId)
      .map(response => response.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/external-user/advance-details/advance-payment-status/Service/advance-payment-status-service.service.ts